var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMInicio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 285,
    viewBox: "0 0 321 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.889 142.222C320.889 152.241 312.529 160.09 303.055 160.09H285.222L285.612 249.264C285.612 250.767 285.5 252.27 285.333 253.772V262.734C285.333 275.036 275.358 285 263.042 285H254.125C253.512 285 252.899 285 252.286 284.944C251.506 285 250.726 285 249.945 285H231.833H218.458C206.142 285 196.167 275.036 196.167 262.734V249.375V213.75C196.167 203.897 188.197 195.938 178.333 195.938H142.667C132.803 195.938 124.833 203.897 124.833 213.75V249.375V262.734C124.833 275.036 114.858 285 102.542 285H89.1667H71.3891C70.5531 285 69.7172 284.944 68.8812 284.889C68.2125 284.944 67.5437 285 66.875 285H57.9583C45.6422 285 35.6667 275.036 35.6667 262.734V200.391C35.6667 199.89 35.6667 199.333 35.7224 198.832V160.09H17.8333C7.80208 160.09 0 152.297 0 142.222C0 137.212 1.67188 132.759 5.57292 128.862L148.462 4.45312C152.364 0.556641 156.822 0 160.723 0C164.624 0 169.082 1.11328 172.426 3.89648L314.758 128.862C319.217 132.759 321.446 137.212 320.889 142.222Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMInicio);
export default __webpack_public_path__ + "static/media/m-inicio.dd2ead84e6df327e004a6e19a2ba1406.svg";
export { ForwardRef as ReactComponent };